import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

// Old emailed links still land here. Tokens never authenticate or choose identity.
export default function InstructorSignup() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const refresh = async () => {
    try { const response = await api.get('/instructors/claimable'); setData(response.data); setError(''); }
    catch (e) { setError(e.response?.data?.message || 'Unable to load classes'); }
  };
  useEffect(() => { refresh(); }, []);
  const claim = async id => {
    setBusy(true);
    try {
      await api.post('/instructors/claim-class', { classEventId: id });
      await refresh();
    } catch (e) { setError(e.response?.data?.message || 'Claim failed; refresh and try again'); }
    finally { setBusy(false); }
  };
  return <main id="instructor-claim-page" className="max-w-3xl mx-auto p-6 space-y-4">
    <h1 className="text-2xl font-bold">Classes needing instructors</h1>
    <p>Sign in with your existing Hello PC account. Its email must match your active instructor record.</p>
    {!data && <Link to="/login?next=/instructor-signup">Sign in to claim a class</Link>}
    {error && <p role="alert">{error}</p>}
    {data && <p>Claiming as {data.instructor.firstName} {data.instructor.lastName}</p>}
    {data?.classes.length === 0 && <p>No eligible classes currently need an instructor.</p>}
    {data?.classes.map(event => <article key={event.id} className="border rounded p-4 space-y-2">
      <h2 className="font-semibold">{event.eventName}</h2>
      <p>{event.date} · {event.startTime}{event.endTime ? `–${event.endTime}` : ''} · {event.location}</p>
      <button disabled={busy} onClick={() => claim(event.id)} className="border rounded px-3 py-2">Claim this class</button>
    </article>)}
    <button disabled={busy} onClick={refresh}>Refresh availability</button>
  </main>;
}
